export enum EUserIdType {
	ZUPEE_USER_ID = 'zupeeUserId',
	EMAIL = 'userEmail',
	PHONE_NUMBER = 'phoneNumber'
}
export const USER_ID_TYPE_OPTIONS = [
	{ id: EUserIdType.ZUPEE_USER_ID, label: 'ZUPEE USER ID' },
	{ id: EUserIdType.EMAIL, label: 'EMAIL' },
	{ id: EUserIdType.PHONE_NUMBER, label: 'PHONE NUMBER' }
];
